import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false, superAdminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-page">
        <div className="text-text-muted text-sm">Caricamento…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (user.must_change_password && location.pathname !== "/change-password")
    return <Navigate to="/change-password" replace />;
  if (superAdminOnly && user.role !== "super_admin") return <Navigate to="/dashboard" replace />;
  if (adminOnly && user.role !== "admin" && user.role !== "super_admin") return <Navigate to="/dashboard" replace />;
  return children;
};
